import { parseInstant } from "../../utils/dateUtils";
import type { CampaignStatus, CouponStatus } from "../../features/promotions/types";

// Shared by the promotions admin panels (welcome bonus, campaigns, coupons).
const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;
export const CODE_RE = /^[A-Z0-9_-]{3,32}$/;
export const MAX_CREDITS = 1_000_000;
export const REDEMPTIONS_PAGE = 50;

export const STATUS_BADGE: Record<CampaignStatus, string> = {
  live: "bg-emerald-900/60 text-emerald-300",
  scheduled: "bg-blue-900/60 text-blue-300",
  ended: "bg-gray-700 text-gray-300",
  inactive: "bg-red-900/50 text-red-300",
};

export const COUPON_STATUS_BADGE: Record<CouponStatus, { cls: string; label: string }> = {
  live: { cls: STATUS_BADGE.live, label: "Live" },
  scheduled: { cls: STATUS_BADGE.scheduled, label: "Scheduled" },
  expired: { cls: STATUS_BADGE.ended, label: "Expired" },
  inactive: { cls: STATUS_BADGE.inactive, label: "Inactive" },
  exhausted: { cls: "bg-amber-900/50 text-amber-300", label: "Exhausted" },
};

// ── IST helpers ──────────────────────────────────────────────────────────────
/** ISO instant -> value for <input type="datetime-local"> showing IST wall-clock. */
export function isoToIstInput(iso: string | null | undefined): string {
  const d = parseInstant(iso ?? "");
  if (!d) return "";
  return new Date(d.getTime() + IST_OFFSET_MS).toISOString().slice(0, 16);
}

/** <input type="datetime-local"> value (entered as IST) -> ISO string with +05:30. */
export function istInputToIso(v: string): string {
  return `${v.length === 16 ? `${v}:00` : v}+05:30`;
}

export function parseIntStrict(v: string): number | null {
  if (!/^\d+$/.test(v.trim())) return null;
  return parseInt(v.trim(), 10);
}
